import { render, staticRenderFns } from "./FireproofFanova.vue?vue&type=template&id=6791c4be&scoped=true&"
import script from "./FireproofFanova.vue?vue&type=script&lang=js&"
export * from "./FireproofFanova.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6791c4be",
  null
  
)

export default component.exports